export default "__VITE_ASSET__NcQkJV2H__"